var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { PaymentMethod } from '../Reports/Model';
import Touchable from '../../elements/Touchable';
import { Input } from 'reactstrap';
import Text from 'elements/Text';
import { toMoneyDecimal } from '../../helpers/Format';
export var PaymentMethodView = function (_a) {
    var method = _a.method, enabled = _a.enabled, disabledInput = _a.disabledInput, title = _a.title, selected = _a.selected, refInput = _a.refInput, value = _a.value, moneyName = _a.moneyName, small = _a.small, onHandleAllMoneyClick = _a.onHandleAllMoneyClick, onHandleInput = _a.onHandleInput, onClearInput = _a.onClearInput;
    var _disabledInput = disabledInput === undefined ? false : disabledInput;
    var defer = false;
    if (method === PaymentMethod.Due) {
        console.log('value: ', value);
        console.log('refInput: ', refInput);
        defer = value > 0 && method === PaymentMethod.Due;
    }
    if (enabled) {
        return (React.createElement("div", { style: { width: '100%' } },
            React.createElement(Touchable, { disabled: !enabled, onClick: function () {
                    if (onHandleAllMoneyClick) {
                        onHandleAllMoneyClick(method);
                    }
                }, style: __assign({ marginBottom: 0, backgroundColor: selected ? 'green' : undefined }, styleButtonPayment(selected)) }, title),
            React.createElement(Input, { disabled: _disabledInput, style: {
                    backgroundColor: _disabledInput ? 'white' : undefined,
                    borderWidth: _disabledInput ? 0 : undefined
                }, innerRef: refInput, name: method, onBlur: function (event) {
                    onHandleInput(event, refInput);
                    onClearInput(event, refInput);
                }, onKeyPress: function (event) {
                    if (event.charCode === 13) {
                        onHandleInput(event, refInput);
                        onClearInput(event, refInput);
                    }
                } }),
            React.createElement(Text, { small: small, style: {
                    textAlign: 'center',
                    margin: 0,
                    padding: 0,
                    backgroundColor: defer ? 'red' : undefined,
                    color: defer ? 'white' : undefined,
                } }, "".concat(toMoneyDecimal(value, moneyName)))));
    }
    return null;
};
var styleButtonPayment = function (selected) {
    return {
        borderWidth: selected ? 1 : 0,
        borderRadius: selected ? 5 : 0,
        borderColor: 'white',
        backgroundColor: selected ? 'green' : undefined,
        color: selected ? 'white' : undefined
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/components/Payments.tsx
// module id = 1195
// module chunks = 0